import React from 'react'
import { Property } from 'csstype'
import styled from 'styled-components'

/*
This icon was obtained from font awesome:
Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc.
 */

const StyledSvgWrapper = styled.div<{ $width: string; $height: string }>`
  width: ${({ $width }) => $width};
  height: ${({ $width }) => $width};
`

export const Facebook: React.FC<{ size: string; color: Property.Color }> = ({
  size,
  color,
}) => {
  return (
    <StyledSvgWrapper $width={size} $height={size}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 25 25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.0107 14.375L18.6218 10.3935H14.8014V7.8098C14.8014 6.72055 15.3351 5.65879 17.0461 5.65879H18.7829V2.26898C18.7829 2.26898 17.2068 2 15.6999 2C12.5537 2 10.4972 3.90695 10.4972 7.35906V10.3935H7V14.375H10.4972V24H14.8014V14.375H18.0107Z"
          fill={color}
        />
      </svg>
    </StyledSvgWrapper>
  )
}
